/*
 * @Description: 线路管理
 * @Author: lijinpeng
 * @Date: 2022-10-09 14:49:03
 * @LastEditTime: 2023-09-22 14:18:23
 * @LastEditors: WangYuhan
 */

import { get, post, deleted, prefix } from './base';

// 线路列表查询
export function postRoutePageList(data) {
  return post(`${prefix}routeInfo/pageList`, data);
}

// 根据企业ID查询线路列表
export function getRouteListByBid(params) {
  return get(`${prefix}routeInfo/group/business/project/list`, params);
}

// 线路新增
export function postRouteAdd(data) {
  return post(`${prefix}routeInfo/insert`, data);
}

// 线路编辑
export function postRouteUpdate(data) {
  return post(`${prefix}routeInfo/update`, data);
}

// 根据线路ID删除线路
export function deleteRoute(params) {
  return deleted(`${prefix}routeInfo/deleteById`, params);
}

// 线路导出
export const routeExportUrl = `${prefix}routeInfo/list/export`;

// 根据线路ID查询线路详情
export function getRouteDetailById(params) {
  return get(`${prefix}routeInfo/detailById`, params);
}

// 自动计算运输距离/时长
export function postDistanceLength(data) {
  return post(`${prefix}routeInfo/distanceLengthCalculator`, data);
}

// 按量计算方式-结算总金额和油款
export function postGoodsPriceCalculator(data) {
  return post(`${prefix}routeInfo/v2/goodsPriceCalculator`, data);
}
